import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Shown while the signed-in user's role is resolving, or for unrecognized roles.
 */
export default function WorkspaceRoleFallback({ loading = false, role = null }) {
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 280,
          gap: 2,
        }}
      >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary">
          Loading your workspace…
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ py: 4, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom>
        Workspace unavailable
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {role
          ? `No dashboard is configured for the "${role.replace(/_/g, ' ')}" role yet.`
          : 'Your account profile is missing a role. Contact your administrator.'}
      </Typography>
    </Box>
  );
}
